import { RudderAnalytics } from '@rudderstack/analytics-js';
import config from '../../../../config';
var RudderstackTracker = /** @class */ (function () {
    function RudderstackTracker() {
        this.rudderAnalytics = null;
        try {
            this.disabled = !config.analytics.Rudderstack.writeKey || !config.analytics.Rudderstack.dataPlaneUrl;
            if (!this.disabled) {
                this.rudderAnalytics = new RudderAnalytics();
                this.rudderAnalytics.load(config.analytics.Rudderstack.writeKey, config.analytics.Rudderstack.dataPlaneUrl, {});
            }
        }
        catch (e) {
            console.error('Error initializing Rudderstack', e);
            this.disabled = true;
        }
    }
    RudderstackTracker.prototype.shouldTrack = function () {
        return !this.disabled && !!this.rudderAnalytics;
    };
    RudderstackTracker.prototype.identify = function (userId, userTraits) {
        try {
            if (this.shouldTrack()) {
                this.rudderAnalytics.identify(userId, userTraits);
            }
        }
        catch (e) {
            console.error('Error identifying user in Rudderstack', e);
        }
    };
    RudderstackTracker.prototype.trackPageVisit = function () {
        try {
            if (this.shouldTrack()) {
                this.rudderAnalytics.page();
            }
        }
        catch (e) {
            console.error('Error tracking page visit in Rudderstack', e);
        }
    };
    RudderstackTracker.prototype.track = function (eventName, properties) {
        try {
            if (this.shouldTrack()) {
                this.rudderAnalytics.track(eventName, properties);
            }
        }
        catch (e) {
            console.error('Error tracking event in Rudderstack', e);
        }
    };
    RudderstackTracker.getInstance = function () {
        if (RudderstackTracker.instance === null) {
            RudderstackTracker.instance = new RudderstackTracker();
        }
        return RudderstackTracker.instance;
    };
    RudderstackTracker.init = function () {
        RudderstackTracker.getInstance();
    };
    RudderstackTracker.instance = null;
    return RudderstackTracker;
}());
export { RudderstackTracker };
RudderstackTracker.instance = null;
